(function () {
  const STORAGE_KEY = "19keys:capture-queue";
  const MAX_ITEMS = 120;

  function readQueue() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch (_error) {
      return [];
    }
  }

  function safeFormData(form) {
    const formData = new FormData(form);
    const payload = {};
    for (const [key, value] of formData.entries()) {
      const normalized = String(value).trim();
      const normalizedKey = key.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
      if (/email|phone|name/.test(normalizedKey)) {
        payload[`has_${normalizedKey}`] = Boolean(normalized);
      } else if (payload[key]) {
        payload[key] = Array.isArray(payload[key]) ? payload[key].concat(normalized) : [payload[key], normalized];
      } else {
        payload[key] = normalized;
      }
    }
    return payload;
  }

  function isCaptureForm(form) {
    return Boolean(
      form &&
        (form.dataset.connectorAction === "capture-bridge" ||
          form.hasAttribute("data-capture-form") ||
          form.classList.contains("sm-capture-form") ||
          form.classList.contains("sm-open__form"))
    );
  }

  function bridgeCapture(form) {
    if (!isCaptureForm(form)) return null;
    const entry = {
      id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
      timestamp: new Date().toISOString(),
      source_page: window.location.pathname.split("/").pop() || "index.html",
      world_id: form.dataset.worldId || document.body.dataset.worldId || "unknown",
      route_id: form.dataset.routeId || "unmapped",
      success_event: form.dataset.successEvent || "",
      connector_id: form.dataset.connectorId || "",
      adapter_id: form.dataset.connectorAdapter || "",
      capture_status: form.dataset.captureStatus || "local-comp",
      crm_segment_key: form.dataset.crmSegmentKey || "",
      sms_segment_key: form.dataset.smsSegmentKey || "",
      capture_destination: form.dataset.captureDestination || "",
      payload_shape: safeFormData(form),
    };
    const queue = readQueue().concat(entry).slice(-MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(queue));
    document.documentElement.dataset.captureBridgeReady = "true";
    document.documentElement.dataset.lastCaptureEvent = entry.success_event || entry.route_id;
    document.documentElement.dataset.lastCaptureStatus = entry.capture_status;
    window.dispatchEvent(new CustomEvent("19keys:capture-bridged", { detail: entry }));
    return entry;
  }

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target.closest("form[data-connector-action='capture-bridge'], form[data-capture-form], form.sm-capture-form, form.sm-open__form");
      if (!form) return;
      if (form.dataset.captureStatus === "credential-gated") event.preventDefault();
      const entry = bridgeCapture(form);
      const note = form.querySelector("[data-form-note], [data-form-result]");
      if (entry && note && !note.textContent) {
        note.textContent = "Request staged in the connector queue.";
      }
    },
    true
  );

  window.__19keysCaptureBridge = {
    clear: () => localStorage.removeItem(STORAGE_KEY),
    read: readQueue,
    bridgeCapture,
  };
  document.documentElement.dataset.captureBridgeReady = "true";
})();
